(function () {
  const root = document.documentElement;
  const bundlePriceSelector = [
    '.bundle-item-price',
    '.bundle-item-old-price',
    '.orichi-money',
    '.orichi-discount-price',
    '.orichi-discounted-price'
  ].join(',');
  const moneyPattern = /^(\D*?)(-?\d{1,3}(?:\.\d{3})+(?:,\d{2})|-?\d{1,3}(?:,\d{3})+(?:\.\d{2})|-?\d+(?:,\d{2})|-?\d+(?:\.\d{2}))(.*)$/;

  function taxesIncluded() {
    return root.dataset.gstTaxesIncluded !== 'false';
  }

  function parseMoney(text) {
    const match = text.trim().match(moneyPattern);
    if (!match) return null;

    const number = match[2];
    const comma = /,\d{2}$/.test(number);
    const normalized = comma ? number.replace(/\./g, '').replace(',', '.') : number.replace(/,/g, '');
    const amount = Number(normalized);
    if (!Number.isFinite(amount)) return null;

    return {
      cents: Math.round(amount * 100),
      comma: comma,
      prefix: match[1],
      suffix: match[3]
    };
  }

  function formatCents(cents, comma) {
    const sign = cents < 0 ? '-' : '';
    const abs = Math.abs(cents);
    const whole = String(Math.floor(abs / 100));
    const fraction = String(abs % 100).padStart(2, '0');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
    return sign + grouped + (comma ? ',' : '.') + fraction;
  }

  function displayCents(catalogCents, excluding) {
    if (taxesIncluded()) {
      return excluding ? Math.round((catalogCents * 10) / 11) : catalogCents;
    }
    return excluding ? catalogCents : Math.round((catalogCents * 11) / 10);
  }

  function syncBundlePrices() {
    const excluding = root.classList.contains('gst-ex');

    document.querySelectorAll(bundlePriceSelector).forEach((el) => {
      const parsed = parseMoney(el.textContent);
      if (!parsed) return;

      let catalog = el.dataset.gstCatalog == null ? null : Number(el.dataset.gstCatalog);
      if (catalog == null) {
        catalog = parsed.cents;
      } else {
        const including = displayCents(catalog, false);
        const excludingCents = displayCents(catalog, true);
        if (parsed.cents !== including && parsed.cents !== excludingCents) catalog = parsed.cents;
      }

      el.dataset.gstCatalog = String(catalog);
      const target = displayCents(catalog, excluding);
      if (parsed.cents === target) return;
      el.textContent = parsed.prefix + formatCents(target, parsed.comma) + parsed.suffix;
    });
  }

  function sync() {
    const excluding = root.classList.contains('gst-ex');
    document.querySelectorAll('.gst-switch').forEach((button) => {
      button.setAttribute('aria-pressed', excluding ? 'true' : 'false');
      button.setAttribute(
        'aria-label',
        excluding
          ? 'Prices exclude GST. Show prices including GST'
          : 'Prices include GST. Show prices excluding GST'
      );
    });
    syncBundlePrices();
  }

  function setMode(excluding) {
    root.classList.toggle('gst-ex', excluding);
    try {
      localStorage.setItem('gst-display', excluding ? 'ex' : 'inc');
    } catch (error) {}
    sync();
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.gst-switch');
    if (!button) return;
    setMode(!root.classList.contains('gst-ex'));
  });

  document.addEventListener('shopify:section:load', sync);

  let bundleSyncScheduled = false;
  function scheduleBundleSync() {
    if (bundleSyncScheduled) return;
    bundleSyncScheduled = true;
    requestAnimationFrame(() => {
      bundleSyncScheduled = false;
      syncBundlePrices();
    });
  }

  if (document.body) {
    new MutationObserver(scheduleBundleSync).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  sync();
})();
